import branding from 'shared/app/model/branding';
import { createSelector } from '@reduxjs/toolkit';
import { LegacyDevice } from 'console/device/device';
import { DevicePermission } from '../../../device/device_ts';
import { selectSelectedDevice } from 'entities/device/lib';
export const getPhotosFromServer = (device_id, time_from) => async (dispatch, getState, { api }) => {
    dispatch({
        type: 'GET_PHOTOS_FROM_SERVER__REQUEST',
    });
    try {
        let photos = [];
        if (branding.show_photos) {
            photos = (await api.get_photos(device_id, time_from)).photos;
        }
        dispatch({
            type: 'GET_PHOTOS_FROM_SERVER__OK',
            photos,
            device_id,
        });
    }
    catch (error) {
        dispatch({
            type: 'GET_PHOTOS_FROM_SERVER__FAIL',
            error: error?.json?.error_ui ??
                error?.json?.error ??
                'Не удалось отправить запрос',
        });
    }
};
export const newPhotoFromServer = (device_id, unixtime, filename) => (dispatch) => dispatch({
    type: 'NEW_PHOTO_FROM_SERVER',
    device_id,
    unixtime,
    filename,
});
const empty_array = [];
export const select_device_photo = createSelector((state) => selectSelectedDevice(state), (state) => state.camera_photos, (device, camera_photos) => device == null ? empty_array : camera_photos?.[device.id] ?? empty_array);
export function isAvailablePhotos(account_id, device) {
    if (device == null) {
        return false;
    }
    return (device?.camera_available != null &&
        LegacyDevice.has_access(account_id, device, DevicePermission.view_state));
}
